"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _GraphTitle = require("../GraphTitle");

var _Loader = require("../Loader");

var _LazyCharts = require("../LazyCharts");

var _AnalyticsDateFormatter = _interopRequireDefault(require("../AnalyticsDateFormatter"));

var _axios = _interopRequireDefault(require("axios"));

var _percentageVotesUtils = require("./percentageVotesUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PercentageTotalVotesPerMonth = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PercentageTotalVotesPerMonth, _Component);

  var _super = _createSuper(PercentageTotalVotesPerMonth);

  function PercentageTotalVotesPerMonth(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PercentageTotalVotesPerMonth);
    _this = _super.call(this, props);

    _this.setState({
      isLoading: true,
      totalVotes: []
    });

    return _this;
  }

  (0, _createClass2.default)(PercentageTotalVotesPerMonth, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.isIdeaStatusMappingSetup !== prevProps.isIdeaStatusMappingSetup)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$props, startDate, endDate, res;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.props.isIdeaStatusMappingSetup) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.setState({
                  isLoading: true
                });
                _this$props = this.props, startDate = _this$props.startDate, endDate = _this$props.endDate;
                _context2.next = 6;
                return _axios.default.post('/analyticsV2/totalVotesOverTime', {
                  filters: {
                    start: _AnalyticsDateFormatter.default.formatDate(startDate),
                    end: _AnalyticsDateFormatter.default.formatDate(endDate, false),
                    group: 'monthly'
                  }
                });

              case 6:
                res = _context2.sent;
                this.setState({
                  totalVotes: res.data,
                  isLoading: false
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchData() {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          shouldChartRedraw = _this$props2.shouldChartRedraw,
          isIdeaStatusMappingSetup = _this$props2.isIdeaStatusMappingSetup;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          totalVotes = _this$state.totalVotes;
      return (0, _preact.h)("div", {
        className: "graph-row ".concat(!isIdeaStatusMappingSetup ? 'graph-row-no-data' : '')
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        customClass: "with-legend",
        title: "% Total votes delivered per month",
        tooltipMessage: "The percentage of the cumulative total votes that have been delivered, shown on a monthly basis. Excludes closed votes."
      }), !isIdeaStatusMappingSetup ? (0, _preact.h)("div", {
        className: "graph-row-no-data-text"
      }, "There's no data yet") : isLoading ? (0, _preact.h)(_Loader.Loader, null) : (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: (0, _percentageVotesUtils.getBarChartDataDataSet)(totalVotes),
        options: (0, _percentageVotesUtils.getBarChartOptions)()
      }));
    }
  }]);
  return PercentageTotalVotesPerMonth;
}(_preact.Component);

var _default = PercentageTotalVotesPerMonth;
exports.default = _default;